import { render, staticRenderFns } from "./mallGoods.vue?vue&type=template&id=02573e33&"
import script from "./mallGoods.vue?vue&type=script&lang=js&"
export * from "./mallGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports